// extracted by mini-css-extract-plugin
module.exports = {"createFormStepTwo":"styles_createFormStepTwo__15mCG","formElement":"styles_formElement__2R4Qh","cursorPointer":"styles_cursorPointer__3oMRz"};